import { render, staticRenderFns } from "./code.vue?vue&type=template&id=2f82309c&"
import script from "./code.vue?vue&type=script&lang=js&"
export * from "./code.vue?vue&type=script&lang=js&"
import style0 from "./code.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports